module.exports = __webpack_public_path__ + "img/12.c3b53397.jpg";